import { render, staticRenderFns } from "./SolutionsSwiper.vue?vue&type=template&id=59dff000&scoped=true"
import script from "./SolutionsSwiper.vue?vue&type=script&lang=js"
export * from "./SolutionsSwiper.vue?vue&type=script&lang=js"
import style0 from "./SolutionsSwiper.vue?vue&type=style&index=0&id=59dff000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dff000",
  null
  
)

export default component.exports